var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('input',{attrs:{"type":"text","name":_vm.name,"id":_vm.id},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./admin/src/js/components/AcInput.vue